import {getAccessToken} from '~/utils/getAccessToken';

export const apiFetch = async (request, opts = {}) => {
  const config = useRuntimeConfig();
  const tokenResult = await getAccessToken();
  if (!tokenResult || !tokenResult.accessToken) return false;
  const {accessToken, activeOrg} = tokenResult;

  // Extract signal from opts if provided
  const {signal, ...fetchOpts} = opts;

  return $fetch(request, {
    baseURL: config.public.apiBaseUrl,
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'X-Vector-Org': activeOrg || null,
    },
    signal, // Pass the AbortSignal to $fetch
    ...fetchOpts,
  });
};
